import { type Provider, ProviderEnum } from '@dynamic-labs/sdk-api-core';

import { assertDefined } from '../../../../../../../utils/assertDefined';

const APPLE_RESPONSE_MODE = 'form_post' as const;
const APPLE_RESPONSE_TYPE = 'code id_token' as const;

type AddOAuthUrlParamsOptions = {
  /** When true, adds prompt=consent to force Google to return a fresh refresh token. */
  isGoogleDriveBackupEnabled?: boolean;
};

/** Helper function to add OAuth URL parameters to a given base URL. */
export const addOAuthUrlParams = (
  provider: Provider,
  baseUrl: URL,
  options: AddOAuthUrlParamsOptions = {}
): URL => {
  assertDefined(provider.clientId, 'Client ID not found');
  assertDefined(provider.provider, 'Provider type not found');
  assertDefined(provider.redirectUrl, 'Redirect URL not found');

  const providerType = provider.provider;

  baseUrl.searchParams.set('client_id', provider.clientId);
  baseUrl.searchParams.set('response_type', 'code');
  baseUrl.searchParams.set('redirect_uri', provider.redirectUrl);

  if (providerType === ProviderEnum.Tiktok) {
    baseUrl.searchParams.delete('client_id');
    baseUrl.searchParams.set('client_key', provider.clientId);
  }

  if (providerType === ProviderEnum.Google) {
    baseUrl.searchParams.set('access_type', 'offline');

    if (options.isGoogleDriveBackupEnabled) {
      baseUrl.searchParams.set('prompt', 'consent');
    }
  }

  // Add logic for providers that require additional parameters
  if (providerType === ProviderEnum.Apple) {
    baseUrl.searchParams.set('response_mode', APPLE_RESPONSE_MODE);
    baseUrl.searchParams.set('response_type', APPLE_RESPONSE_TYPE);
  }

  if (provider.scopes) {
    baseUrl.searchParams.set('scope', provider.scopes);
  }

  return baseUrl;
};
